import React from "react";
import { Chip, useTheme } from "@mui/material";
import { ActivityStatus } from "../../types/activityTypes";
import { getActivityStatusLabel } from "./activityLabels";

interface ActivityStatusChipProps {
  status: ActivityStatus;
}

/**
 * Status chip for the visual activity state.
 */
const ActivityStatusChip = ({ status }: ActivityStatusChipProps) => {
  const theme = useTheme();

  if (status === ActivityStatus.WAITING_FOR_CUSTOMER) {
    return (
      <Chip
        size="small"
        variant="outlined"
        label={getActivityStatusLabel(status)}
        sx={{
          backgroundColor: theme.palette.common.white,
          borderColor: theme.palette.grey[500],
          color: theme.palette.text.primary,
          fontWeight: 600,
        }}
      />
    );
  }

  return (
    <Chip
      size="small"
      label={getActivityStatusLabel(status)}
      sx={{
        backgroundColor: status === ActivityStatus.DONE ? theme.palette.success.main : theme.palette.grey[300],
        color: status === ActivityStatus.DONE ? theme.palette.success.contrastText : theme.palette.text.primary,
        fontWeight: 600,
      }}
    />
  );
};

export default ActivityStatusChip;
